import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { Button, Menu, MenuItem, MenuList, MenuPopover, MenuTrigger } from '@fluentui/react-components';
import { Add20Regular, Image20Regular, GlanceHorizontalSparkles20Regular } from '@fluentui/react-icons';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';

export const CreateAnotherAdMenu = ({
  onCreateWithAI,
  onCreateFromExistingImage,
}) => {
  const i18n = useContext(I18nContext);
  const activity = useContext(ActivityContext);

  const handleCreateWithAI = useCallback(() => {
    onCreateWithAI();

    if (activity) {
      activity.signal('[Creating another ad] - With AI');
    }
  }, [onCreateWithAI, activity]);

  const handleCreateFromExistingImage = useCallback(() => {
    onCreateFromExistingImage();

    if (activity) {
      activity.signal('[Creating another ad] - From existing image');
    }
  }, [onCreateFromExistingImage, activity]);

  return (
    <Menu>
      <MenuTrigger>
        <Button icon={<Add20Regular />}>
          {i18n.getString(_TL_('Create another ad'))}
        </Button>
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          <MenuItem icon={<GlanceHorizontalSparkles20Regular />} onClick={handleCreateWithAI}>
            {i18n.getString(_TL_('Create with AI'))}
          </MenuItem>
          <MenuItem icon={<Image20Regular />} onClick={handleCreateFromExistingImage}>
            {i18n.getString(_TL_('Use existing image'))}
          </MenuItem>
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};

CreateAnotherAdMenu.propTypes = {
  onCreateWithAI: PropTypes.func.isRequired,
  onCreateFromExistingImage: PropTypes.func.isRequired,
};
